import { default as axios } from "./config.js";

export default {
	// Auth
	loginApi: (params) => axios.post("login", params),
	logoutApi: (sid) => axios.post("logout", { sid }),
	sendmail: (params) => axios.post("sendmail", params),
	suggestion: (params) => axios.post("suggestions", params),
	getUTCDateTime: () => axios.get("utc-datetime-get"),
	// Blog
	getBlogs: (params) => axios.get("blogs", { params }),
	getBlog: (link) => axios.get(`blogs/${link}`),
	// Blog Admin
	adminLogin: (params) => axios.post("admin/login", params),
	checkAdminSession: () => axios.get("admin/check-session"),
	uploadBlogImage: (formData) =>
		axios.post("admin/upload-image", formData, {
			headers: { "Content-Type": "multipart/form-data" },
		}),
	createBlog: (payload) => axios.post("admin/blogs", payload),
	updateBlog: (link, payload) => axios.put(`admin/blogs/${link}`, payload),
};
